<div
  [rtTooltip]="tooltip"
  [rtTooltipEnabled]="!!tooltip?.length"
  [rtTooltipHasTextAlignCenter]="true"
  class="rt-card"
  [class.rt-card-clickable]="!disabled"
  [class.rt-card-disabled]="disabled"
  layout-full-width
>
  @if (description) {
    <rt-checkbox
      [formControl]="control"
      [disabled]="disabled"
      [fullWidthLabel]="!!isNew"
      (valueChange)="valueChanges.emit($event)"
      padding
      layout-full-width
    >
      <ng-container [ngTemplateOutlet]="defaultTemplate" />
      <span class="description" [innerHTML]="description"></span>
    </rt-checkbox>
  } @else {
    <rt-checkbox
      [formControl]="control"
      [disabled]="disabled"
      [fullWidthLabel]="!!isNew"
      (valueChange)="valueChanges.emit($event)"
      padding-small-x
      layout-full-width
    >
      <ng-container [ngTemplateOutlet]="defaultTemplate" />
    </rt-checkbox>
  }
</div>

<ng-template #defaultTemplate>
  <span layout layout-horizontal layout-align-items-center layout-full-width>
    <span layout layout-align-items-center>
      {{ label }}
      @if (helpTooltip) {
        <rt-icon
          name="help-outline"
          [rtTooltip]="helpTooltip"
          [rtTooltipPosition]="'below'"
          [rtTooltipHasTextAlignCenter]="true"
          margin-left-small-x
        ></rt-icon>
      }
    </span>
    @if (isNew) {
      <rt-badge color="primary-gradient" [text]="'app.common.new' | translate" margin-left-auto />
    }
  </span>
</ng-template>
